<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>{{ $t("message.consultaHistorico") }}</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <div v-show="!form.consultar_numero" class="form-field select">
                <div class="select-field">
                  <select
                    @change="buscar"
                    name="tipoFecha"
                    v-model="form.tipo_fecha"
                    id="tipoFecha"
                  >
                    <option value="I">{{ $t("message.fechaIngreso") }}</option>
                    <option value="S">{{ $t("message.fechaSalida") }}</option>
                  </select>
                  <label for="tipoFecha">{{ $t("message.tipoFecha") }}</label>
                  <span
                    v-if="errores.tipo_fecha"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.tipo_fecha[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="!form.consultar_numero" class="form-field select2">
                <div class="select2-field">
                  <v-select
                    @input="inputPatio"
                    id="patio"
                    v-model="selectedPatio"
                    :options="patios"
                    label="name"
                  ></v-select>
                  <label for="patio">Patio</label>
                </div>
              </div>
              <div v-show="!form.consultar_numero" class="form-field">
                <div class="datepicker-field">
                  <date-picker
                    @enterkey="buscar"
                    type="date"
                    id="desde"
                    v-model="form.desde"
                  ></date-picker>
                  <label>{{ $t("message.desde") }}</label>
                  <span
                    v-if="errores.desde"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="!form.consultar_numero" class="form-field">
                <div class="datepicker-field">
                  <date-picker
                    @enterkey="buscar"
                    type="hasta"
                    id="hasta"
                    v-model="form.hasta"
                  ></date-picker>
                  <label>{{ $t("message.hasta") }}</label>
                  <span
                    v-if="errores.hasta"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    placeholder="Seleccione..."
                    @input="inputTiposEstado"
                    multiple
                    id="tipos_estado"
                    label="descripcion"
                    :options="optionsEstados"
                    v-model="selectedTiposEstado"
                  ></v-select>
                  <label for="tipos_estado">Estado</label>
                </div>
              </div>
              <div class="form-field">
                <p>
                  <label for="consultarNumero">
                    <input
                      type="checkbox"
                      name="consultarNumero"
                      id="consultarNumero"
                      v-model="form.consultar_numero"
                    />
                    <span>{{ $t("message.filterContainer") }}</span>
                  </label>
                </p>
              </div>
              <div v-show="form.consultar_numero" class="form-field">
                <input-field
                  @keyup.enter="buscar"
                  name="numeroContenedor"
                  v-model="form.numero_contenedor"
                  id="numeroContenedor"
                  placeholder="#######"
                  >{{ $t("message.numeroContenedor") }}</input-field
                >
              </div>
              <button @click="buscar" type="button" class="btn-info">
                <i class="fa fa-search"></i>
                <span>{{ $t("message.buscar") }}</span>
              </button>
            </div>
            <div class="table-responsive mt-3">
              <k-table
                :buttons="[
                  {
                    class: 'btn-success btn--text',
                    icon: 'fa-share',
                    event: 'verContenedor',
                  },
                  {
                    class: 'btn-info btn--text',
                    icon: 'fa-edit',
                    event: 'editarContenedor',
                  },
                  {
                    class: 'btn-secondary btn--text',
                    icon: 'fa-cog',
                    event: 'editarPropiedades',
                  },
                ]"
                @editarContenedor="editarContenedor"
                @editarPropiedades="editarPropiedades"
                @verContenedor="verContenedor"
                @enviarErrores="obtenerErrores"
                :noForms="true"
                :params="form"
                :mostrarTodos="false"
                :columns="columns"
                :path="path"
                ref="consultaHistorico"
                :deleteButton="false"
                :createButton="false"
                :editButton="false"
              ></k-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :clickToClose="false"
      width="75%"
      height="auto"
      scrollable
      name="edicionHistorico"
    >
      <edicion-historico
        :esMaquina="currentIsMaquina"
        @aceptar="aceptarContenedor"
        v-model="currentContenedor"
        :number="currentNumber"
        @cancelar="$modal.hide('edicionHistorico')"
      ></edicion-historico>
    </modal>
    <modal
      :clickToClose="false"
      width="75%"
      height="auto"
      scrollable
      name="editarPropiedades"
    >
      <editar-unidad
        :numeroContenedor="currentNumber"
        :numeroSecuencia="currentSecuencia"
        :puede_editar_status="puede_editar_status"
        :puede_eliminar="puede_eliminar"
        :puede_editar_gate_in="puede_editar_gate_out"
        :puede_editar_gate_out="puede_editar_gate_out"
        :puede_editar_in="puede_editar_in"
        :puede_editar_out="puede_editar_out"
        :puede_editar_caja="puede_editar_caja"
        :puede_editar_maquina="puede_editar_maquina"
        :puede_enviar_edi_in="puede_enviar_edi_in"
        :puede_enviar_edi_out="puede_enviar_edi_out"
        @cerrarUnidad="cerrarUnidad"
        @eliminarUnidad="eliminarUnidad"
        ref="editarUnidad"
        v-model="currentUnidad"
      ></editar-unidad>
    </modal>
  </div>
</template>

<script>
import EditarUnidad from "./sistema/EditarUnidad.vue";
export default {
  components: { EditarUnidad },
  props: {
    patios: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    puede_editar_status: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_eliminar: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_caja: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_maquina: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_out: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      patioDefault: patioDefault,
      optionsEstados: [
        {
          id: "F",
          descripcion: "No facturados",
        },
        {
          id: "A",
          descripcion: "No aprobados",
        },
      ],
      selectedTiposEstado: [],
      selectedPatio: null,
      currentIsMaquina: false,
      currentNumber: "",
      currentSecuencia: "",
      currentContenedor: null,
      currentUnidad: null,
      errores: {},
      form: {
        tipo_fecha: "S",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        consultar_numero: false,
        numero_contenedor: "",
        patio_id: "",
        tipos_estado: [],
      },
      path: url + "/historico",
      columns: [
        {
          display: this.$t("message.secuencia"),
          value: "secuencia",
        },
        {
          display: this.$t("message.cliente"),
          value: "customer_code",
        },
        {
          display: this.$t("message.numeroContenedor"),
          value: "number",
        },
        {
          display: this.$t("message.patio"),
          value: "yard_code",
        },
        {
          display: this.$t("message.placa"),
          value: "layout",
        },
        {
          display: this.$t("message.placaOut"),
          value: "segmento",
        },
        {
          display: this.$t("message.size"),
          value: "size",
        },
        {
          display: this.$t("message.fechaIngreso"),
          value: "gate_in_date",
        },
        {
          display: this.$t("message.damageType"),
          value: "type_damage",
        },
        {
          display: this.$t("message.fechaSalida"),
          value: "gate_out_date",
        },
        {
          display: this.$t("message.observacion"),
          value: "observacion",
        },
      ],
    };
  },
  methods: {
    inputTiposEstado: function () {
      this.form.tipos_estado.splice(0, this.form.tipos_estado.length);
      for (let i = 0; i < this.selectedTiposEstado.length; i++)
        this.form.tipos_estado.push(this.selectedTiposEstado[i].id);
      this.buscar();
    },
    inputPatio: function () {
      if (this.selectedPatio != null)
        this.form.patio_id = this.selectedPatio.code;
      else this.form.patio_id = "";
    },
    aceptarContenedor: function () {
      this.$modal.hide("edicionHistorico");
      this.buscar();
    },
    buscar: function () {
      this.$refs.consultaHistorico.loadRows();
    },
    obtenerErrores: function (errores) {
      this.errores = errores;
    },
    verContenedor: function (row) {
      window.open(
        url + "/historico/" + row.secuencia + "/" + row.number,
        "_blank"
      );
    },
    editarContenedor: function (row) {
      this.currentContenedor = {
        aprobado_m: row.aprobado_m === "S",
        aprobado_b: row.aprobado_b === "S",
        invoiced_box: row.invoiced_box === "S",
        invoiced_machine: row.invoiced_machine === "S",
        date_i_b:
          row.date_i_b !== null
            ? moment(row.date_i_b).format("YYYY-MM-DD")
            : "",
        date_i_m:
          row.date_i_m !== null
            ? moment(row.date_i_m).format("YYYY-MM-DD")
            : "",
        date_a_b:
          row.date_a_b !== null
            ? moment(row.date_a_b).format("YYYY-MM-DD")
            : "",
        date_a_m:
          row.date_a_m !== null
            ? moment(row.date_a_m).format("YYYY-MM-DD")
            : "",
        secuencia: row.secuencia,
        _method: "PUT",
      };
      this.currentNumber = row.number;
      this.currentIsMaquina = row.is_maquina === "S";
      this.$modal.show("edicionHistorico");
    },
    editarPropiedades: function (row) {
      this.currentNumber = row.number;
      this.currentSecuencia = row.secuencia;
      this.$modal.show("editarPropiedades");
    },
    eliminarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades');
      this.$refs.consultaHistorico.loadRows();
    },
    cerrarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades')
    },
    quitarShorcutUnidad: function () {
      document.removeEventListener("keydown", this.$refs.editarUnidad.pressed);
    },
  },
  mounted: function () {
    if (this.patioDefault != null && this.patioDefault != '') {
      for (let i = 0; i < this.patios.length; i++) {
        if (this.patios[i].code == this.patioDefault) {
          this.selectedPatio = this.patios[i];
          this.inputPatio();
          break;
        }
      }
    }
    for (let i = 0; i < this.optionsEstados.length; i++) {
      if (this.optionsEstados[i].id === "F") {
        this.selectedTiposEstado.push(this.optionsEstados[i]);
        break;
      }
    }
    this.inputTiposEstado();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/ConsultaHistorico.vue